"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const expect = require("assert");
const sinon_1 = require("sinon");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const tool_service_1 = require("./tool-service");
const errors_1 = require("./errors");
describe('tool service', () => {
    let gulpMock;
    let toolServiceMock;
    let loggerServiceMock;
    let traceServiceMock;
    let requireDriverMock;
    let toolContainerMock;
    let toolPrefix;
    let toolService;
    beforeEach(() => {
        gulpMock = {
            tasks: {},
            task: sinon_1.spy(),
            start: sinon_1.spy()
        };
        toolServiceMock = {
            getTool: sinon_1.spy()
        };
        loggerServiceMock = {
            error: sinon_1.spy(),
            warn: sinon_1.spy(),
            debug: sinon_1.spy(),
            info: sinon_1.spy()
        };
        traceServiceMock = {
            track: sinon_1.spy()
        };
        requireDriverMock = {
            require: sinon_1.spy()
        };
        toolPrefix = 'tool-prefix';
        toolService = new tool_service_1.ToolService(loggerServiceMock, traceServiceMock, toolPrefix, requireDriverMock, () => toolContainerMock);
    });
    describe('.getToolContainerModule()', () => {
        context('when module of the tool can be found extended with the tool prefix', () => {
            const toolModule = { containerModule: {} };
            const toolName = 'toolName';
            beforeEach(() => {
                requireDriverMock.require = sinon_1.spy((name) => {
                    if (name === `${toolPrefix}${toolName}`) {
                        return toolModule;
                    }
                    throw new Error('not found');
                });
            });
            it('returns `containerModule` from module', () => {
                const containerModule = toolService.getToolContainerModule(toolName);
                expect.equal(requireDriverMock.require.calledWith(`${toolPrefix}${toolName}`), true);
                expect.equal(containerModule, toolModule.containerModule);
            });
        });
        context('when module of the tool can be found without the tool prefix', () => {
            const toolModule = { containerModule: {} };
            const toolName = 'toolName';
            beforeEach(() => {
                requireDriverMock.require = sinon_1.spy((name) => {
                    if (name === toolName) {
                        return toolModule;
                    }
                    throw new Error('not found');
                });
            });
            it('returns `containerModule` from module', () => {
                const containerModule = toolService.getToolContainerModule(toolName);
                expect.equal(requireDriverMock.require.calledWith(`${toolPrefix}${toolName}`), true);
                expect.equal(requireDriverMock.require.calledWith(toolName), true);
                expect.equal(containerModule, toolModule.containerModule);
            });
        });
        context('when module of the tool cannot be found either with or without the tool prefix', () => {
            beforeEach(() => {
                requireDriverMock.require = sinon_1.spy(() => {
                    throw new Error('not found');
                });
            });
            it('returns `containerModule` from module', () => {
                expect.throws(() => {
                    toolService.getToolContainerModule('toolName');
                }, err => err instanceof errors_1.NotFoundTool);
            });
        });
    });
    describe('.getTool()', () => {
        it('calls getToolContainerModule synchronously', () => {
            const toolName = 'toolName';
            toolService.getToolContainerModule = sinon_1.spy();
            toolService.getTool(toolName);
            expect.equal(toolService.getToolContainerModule.calledWith(toolName), true);
        });
        it('returns object with .register api', () => {
            const toolName = 'toolName';
            toolService.getToolContainerModule = sinon_1.spy();
            const result = toolService.getTool(toolName);
            expect.equal(typeof result.register, 'function');
        });
        context('when returned .register api is called', () => {
            let tool;
            let registrableTool;
            beforeEach(() => {
                tool = { register: sinon_1.spy() };
                toolContainerMock = new inversify_1.Container();
                toolService.getToolContainerModule = sinon_1.spy(() => new inversify_1.ContainerModule((bind) => {
                    bind(urbanjs_tools_core_1.TYPE_TOOL).toConstantValue(tool);
                }));
            });
            it('registers a task with the given name and parameters', () => {
                registrableTool = toolService.getTool('toolName');
                const taskName = 'taskName';
                const taskConfig = {};
                registrableTool.register(gulpMock, taskName, taskConfig);
                expect.equal(tool.register.calledWith(taskName, taskConfig), true);
            });
            it('gulp instance is registered to the tool container', () => {
                registrableTool = toolService.getTool('toolName');
                const taskName = 'taskName';
                const taskConfig = {};
                registrableTool.register(gulpMock, taskName, taskConfig);
                expect.equal(toolContainerMock.get(urbanjs_tools_core_1.TYPE_DRIVER_GULP), gulpMock);
            });
        });
    });
});
